/* eslint-disable */
<template>
  <div>
    <div class="login">
      <div class="intro">
        <div class="rw pt-4">
          <img src="@/assets/Illustration.svg" />
        </div>
        <div class="rw" style="margin-top: -70px">
          <h3>Work On The Go</h3>
          <p class="slogan">
            Collaborate &nbsp; . &nbsp; Share &nbsp; . &nbsp; Save Files &nbsp;
            . &nbsp; Organise Your Work Flow
          </p>
        </div>
      </div>
      <div class="form">
        <div>
          <div class="logo">
            <a href="http://fexspace.com"
              ><img
                src="../../public/logo-small.png"
                width="120px"
                height="auto"
            /></a>
          </div>
          <h3 class="mb-2">Sign Up</h3>
          <p class="tagline">
            Create your Fexspace account, and choose your plan for your project.
          </p>
          <form @keypress="send" class="mt-4">
            <div class="row input">
              <div class="col-sm-12 col-md-6">
                <!--<label for="firstname">
                              First Name
                            </label>-->
                <input
                  type="text"
                  placeholder="Your first name"
                  v-model="firstname"
                  @focus="input_focus('firstname')"
                  @blur="input_blur('firstname')"
                />
                <span class="err" v-if="error.firstname">*Required</span>
              </div>
              <div class="col-sm-12 col-md-6">
                <!--<label for="lastname">
                              Last Name
                            </label>-->
                <input
                  type="text"
                  placeholder="Your last name"
                  v-model="lastname"
                  @focus="input_focus('lastname')"
                  @blur="input_blur('lastname')"
                />
                <span class="err" v-if="error.lastname">*Required</span>
              </div>
            </div>
            <div class="input mt-4">
              <div class="email">
                <!--<label for="email">
                              Email Address
                            </label>-->
                <template v-if="checkEmail(email) && code != ''">
                  <input
                    type="text"
                    placeholder="Enter email address"
                    disabled
                    v-model="email"
                    @focus="input_focus('email')"
                    @blur="input_blur('email')"
                  />
                </template>
                <template
                  v-if="(!checkEmail(email) || checkEmail(email)) && code == ''"
                >
                  <input
                    type="text"
                    placeholder="Enter email address"
                    v-model="email"
                    @focus="input_focus('email')"
                    @blur="input_blur('email')"
                  />
                </template>
                <span class="err" v-if="error.format"
                  >*Please enter a valid email</span
                >
                <span class="err" v-if="error.exist">*Email already used</span>
                <span class="err" v-if="error.email">*Required</span>
              </div>
            </div>
            <div class="input mt-4" style="margin-bottom: 1em">
              <div class="email">
                <!--<label for="password">
                              Password
                            </label>-->
                <div class="pos">
                  <input
                    :type="[!reveal ? 'password' : 'text']"
                    placeholder="Min. 8 character"
                    v-model="password"
                    @focus="input_focus('password')"
                    @blur="input_blur('password')"
                  />
                  <span
                    class="reveal"
                    style="top: 14px"
                    @click="reveal_password"
                  >
                    <img src="@/assets/No Preview.svg" v-if="!reveal" />
                    <img src="@/assets/eye.svg" v-if="reveal" />
                  </span>
                </div>
                <span class="err" v-if="error.password_length"
                  >*Password length must not be less than 8 characters</span
                >
                <span class="err" v-if="error.password">*Required</span>
              </div>
            </div>
            <div class="text">
              <p>
                By submitting this form, you confirm that you agree to the
                storing and processing of your personal data by Fexspace as
                described in our
                <a
                  :href="[
                    ng
                      ? 'https://fexspace.com/ng/terms-condition'
                      : 'https://fexspace.com/terms-condition',
                  ]"
                  >Terms of Service</a
                >
                and
                <a
                  :href="[
                    ng
                      ? 'http://fexspace.com/ng/privacy-policy'
                      : 'http://fexspace.com/privacy-policy',
                  ]"
                  >Privacy Policy</a
                >
              </p>
            </div>
            <div class="submit mt-4">
              <button type="button" @click="submit">Continue</button>
              <p class="mt-1">
                Already have an account?
                <strong><router-link to="/login">Sign In</router-link></strong>
              </p>
            </div>
            <p class="copy-right mt-5">
              &copy; {{ year }} Fexspace. All Rights Reserved.
            </p>
          </form>
        </div>
      </div>
    </div>
    <loading ref="loading"></loading>
    <loader ref="loader"></loader>
  </div>
</template>
<style scoped>
img {
  max-width: 100%;
}
.err {
  color: #fc6d6c;
  font-size: 14px;
  font-family: "DM Sans";
}
.input {
  margin-bottom: 1em !important;
}
.text {
  text-align: left;
  margin: 0;
  font-family: "DM Sans";
  font-size: 14px;
  color: #4b5458;
  line-height: 19.6px;
}
.copy-right {
  text-align: left;
  margin: 0;
  font-family: "DM Sans";
  font-size: 16px;
  color: #677888;
}
.hr {
  margin: 1em 0;
}
.hr hr {
  flex-grow: 1;
}
.hr hr {
  flex-grow: 1;
}
.hr span {
  color: #4b5458;
  font-family: "DM Sans";
  font-size: 16px;
}
.hr hr:nth-child(1) {
  margin-right: 10px;
  border-top: 1px solid #a7b9cb !important;
}
.hr hr:nth-child(3) {
  margin-left: 10px;
  border-top: 1px solid #a7b9cb !important;
}
.linkedin-text,
.google-text {
  font-family: "DM Sans" !important;
  color: #111 !important;
  font-size: 16px !important;
  font-weight: bold !important;
}
.gmail-login {
  border: 1px solid #ababab;
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  width: 50%;
  height: 55px;
}
.gmail-login span {
  font-weight: normal;
  font-size: 15px;
  margin-left: 0.8em;
}
.linked-login {
  border: 1px solid #ababab;
  cursor: pointer;
  display: flex;
  justify-content: center;
  border-radius: 5px;
  align-items: left;
  height: 55px;
  width: 50%;
}
.linked-login span {
  max-width: 105px;
}
.linked-login img.linkedin-img {
  margin-top: 16px;
}
.linked-login .loader {
  margin-top: 0.3em;
}
.login .form form {
  margin-top: 0;
}
.login .form {
  margin-bottom: 1em !important;
}
.submit {
  margin-bottom: 1em !important;
}
.login .form form button {
  margin-bottom: 0em !important;
}
</style>
<script>
import { mapMutations } from "vuex";
import AuthenticationService from "@/services/AuthenticationService";
import loader from "@/components/Loader";
import loading from "@/components/Loading";
import cookies from "@/services/cookies";
import axios from "axios";

export default {
  components: {
    loader,
    loading,
  },
  data() {
    return {
      firstname: "",
      lastname: "",
      email: "",
      password: "",
      confirm: "",
      reveal: false,
      error: {
        firstname: false,
        lastname: false,
        email: false,
        valid_email: false,
        password: false,
        confirm: false,
        password_length: false,
        mismatch: false,
        exist: false,
        format: false,
      },
      dropdown: false,
      post: true,
      country: "",
      prices: "",
      sticky: false,
      stage: localStorage.getItem("stage") ? localStorage.getItem("stage") : 1,
      user_id: localStorage.getItem("user_id")
        ? localStorage.getItem("user_id")
        : "",
      name: localStorage.getItem("name") ? localStorage.getItem("name") : "",
      code: "",
      ng: false,
      year: "",
      str: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    };
  },
  methods: {
    ...mapMutations(["SET_USER_TOKEN"]),
    checkEmail(email) {
      return this.str.test(this.email);
    },
    show_dropdown() {
      this.dropdown = !this.dropdown;
    },
    reveal_password() {
      this.reveal = !this.reveal;
    },
    logout() {
      this.$refs.logout.logout();
    },
    input_focus(txt) {
      this.error[txt] = false;

      if (txt == "email") {
        this.error.exist = false;
      }
    },
    input_blur(txt) {
      if (this[txt] == "") {
        this.error[txt] = true;
      } else {
        this.error[txt] = false;
      }
    },
    free_plan() {
      this.$refs.loading.load();
      let that = this;

      let data = {
        user_id: this.user_id,
        plan: 1,
        stage: 2,
      };
      AuthenticationService.free_plan(data)
        .then((res) => {
          if (res.data.error == false) {
            that.$refs.loading.close();
            that.$store.commit("SET_USER_TOKEN", cookies.getCookie("token"));
            // cookies.setCookie('regtoken', res.data.token, 6 * 60 * 60 * 1000)
            that.$router.push("setup-account");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    buy(plan) {
      localStorage.setItem("plan", plan);
      this.$router.push("/buy/payment");
    },
    trial(plan) {
      this.$refs.loading.load();
      let that = this;

      let data = {
        user_id: this.user_id,
        plan: plan,
        stage: 2,
      };
      AuthenticationService.trial(data)
        .then((res) => {
          if (res.data.error === false) {
            that.$refs.loading.close();
            that.$store.commit("SET_USER_TOKEN", cookies.getCookie("token"));
            // cookies.setCookie('regtoken', res.data.token, 6 * 60 * 60 * 1000)
            that.$router.push("setup-account");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleScroll() {
      if (window.scrollY >= 555) {
        this.sticky = true;
      } else {
        this.sticky = false;
      }
    },
    send(evt) {
      if (evt.keyCode === 13) {
        this.post = true;
        this.error.exist = false;

        if (this.firstname === "") {
          this.error.firstname = true;
          this.post = false;
        } else {
          this.error.lastname = false;
        }

        if (this.lastname === "") {
          this.error.lastname = true;
          this.post = false;
        } else {
          this.error.lastname = false;
        }

        if (this.email == "") {
          this.error.email = true;
          this.post = true;
        } else {
          this.error.email = false;

          if (this.str.test(this.email) === false) {
            this.error.format = true;
            this.post = false;
          } else {
            this.error.format = false;
          }
        }

        if (this.password === "") {
          this.error.password = true;
          this.post = false;
        } else {
          this.error.password_length = false;
          if (this.password.length < 8) {
            this.error.password_length = true;
            this.post = false;
          } else {
            this.error.password = false;
          }
        }

        if (this.post) {
          this.$refs.loader.load();

          let data = {
            firstname: this.firstname,
            lastname: this.lastname,
            email: this.email,
            password: this.password,
            stage: sessionStorage.getItem("um") == "trial" ? 6 : 1,
            plan: this.$route.query.pn,
            type: this.$route.query.type,
            code: this.code,
            ref: this.ref,
            country: this.country,
          };

          let that = this;

          AuthenticationService.createaccount(data)
            .then((res) => {
              if (res.data.error === true) {
                that.$refs.loader.close();
                that.error.exist = true;
              }

              if (res.data.error === false) {
                sessionStorage.setItem("dir_id", res.data.directory_id);
                
                if (sessionStorage.getItem("um") == "trial") {
                  if (process.env.NODE_ENV == "development") {
                    if (
                      res.data.source !== "" &&
                      res.data.source !== undefined
                    ) {
                      cookies.setCookie(
                        "name",
                        that.firstname + " " + that.lastname,
                        6 * 60 * 60 * 1000
                      );
                      sessionStorage.removeItem("um");
                      window.location = res.data.url;
                    } else {
                      cookies.setCookie(
                        "name",
                        that.firstname + " " + that.lastname,
                        6 * 60 * 60 * 1000
                      );
                      sessionStorage.removeItem("um");
                      // window.location = 'http://192.168.1.2:3000/pricing-free-trial'
                      window.location = "http://192.168.1.2:3000/plan-trial";
                    }
                  } else {
                    if (
                      res.data.source !== "" &&
                      res.data.source !== undefined
                    ) {
                      cookies.setCookie(
                        "name",
                        that.firstname + " " + that.lastname,
                        6 * 60 * 60 * 1000
                      );
                      sessionStorage.removeItem("um");
                      window.location = res.data.url;
                    } else {
                      cookies.setCookie(
                        "name",
                        that.firstname + " " + that.lastname,
                        6 * 60 * 60 * 1000
                      );
                      sessionStorage.removeItem("um");
                      window.location = "https://fexspace.com/plan-trial";
                      // window.location = res.data.url
                    }
                  }
                } else {
                  if (res.data.url !== "") {
                    if (Number(res.data.type) === 1) {
                      // Redirect user to choose a plan
                      cookies.setCookie(
                        "name",
                        that.firstname + " " + that.lastname,
                        6 * 60 * 60 * 1000
                      );
                      cookies.setCookie(
                        "email",
                        that.email,
                        6 * 60 * 60 * 1000
                      );
                      if (
                        this.getCookie("redirect") !== "" &&
                        this.getCookie("redirect") !== null &&
                        this.getCookie("redirect") !== undefined
                      ) {
                        window.location.replace(this.getCookie("redirect"));
                      } else {
                        window.location = "https://app.fexspace.com";
                      }
                    } else {
                      // Redirect user to choose a plan
                      cookies.setCookie(
                        "name",
                        that.firstname + " " + that.lastname,
                        6 * 60 * 60 * 1000
                      );
                      cookies.setCookie(
                        "email",
                        that.email,
                        6 * 60 * 60 * 1000
                      );
                      cookies.setCookie("country", that.country, 6 * 60 * 60 * 1000);
                      cookies.setCookie(
                        "tran_ref",
                        res.data.tran_ref,
                        6 * 60 * 60 * 1000
                      );
                      window.location = res.data.url;
                    }
                  } else {
                    if (Number(res.data.type) === 1) {
                      if (
                        this.getCookie("redirect") !== "" &&
                        this.getCookie("redirect") !== null &&
                        this.getCookie("redirect") !== undefined
                      ) {
                        window.location.replace(this.getCookie("redirect"));
                      } else {
                        window.location = "https://app.fexspace.com";
                      }
                    } else {
                      // User has already chosen a plan redirect him to setup account page
                      that.$router.push("/setup-account");
                    }
                  }
                }
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      }
    },
    submit() {
      this.post = true;
      this.error.exist = false;

      if (this.firstname === "") {
        this.error.firstname = true;
        this.post = false;
      } else {
        this.error.lastname = false;
      }

      if (this.lastname === "") {
        this.error.lastname = true;
        this.post = false;
      } else {
        this.error.lastname = false;
      }

      if (this.email == "") {
        this.error.email = true;
        this.post = true;
      } else {
        this.error.email = false;

        if (this.str.test(this.email) === false) {
          this.error.format = true;
          this.post = false;
        } else {
          this.error.format = false;
        }
      }

      if (this.password === "") {
        this.error.password = true;
        this.post = false;
      } else {
        this.error.password_length = false;
        if (this.password.length < 8) {
          this.error.password_length = true;
          this.post = false;
        } else {
          this.error.password = false;
        }
      }

      if (this.post) {
        this.$refs.loader.load();

        let data = {
          firstname: this.firstname,
          lastname: this.lastname,
          email: this.email,
          password: this.password,
          stage: sessionStorage.getItem("um") == "trial" ? 6 : 1,
          plan: this.$route.query.pn,
          type: this.$route.query.type,
          code: this.code,
          ref: this.ref,
          country: this.country,
        };

        let that = this;

        AuthenticationService.createaccount(data)
          .then((res) => {
            if (res.data.error === true) {
              that.$refs.loader.close();
              that.error.exist = true;
            }

            if (res.data.error === false) {
              sessionStorage.setItem("dir_id", res.data.directory_id);
              if (sessionStorage.getItem("um") == "trial") {
                if (process.env.NODE_ENV == "development") {
                  if (res.data.source !== "" && res.data.source !== undefined) {
                    cookies.setCookie(
                      "name",
                      that.firstname + " " + that.lastname,
                      6 * 60 * 60 * 1000
                    );
                    sessionStorage.removeItem("um");
                    window.location = res.data.url;
                  } else {
                    cookies.setCookie(
                      "name",
                      that.firstname + " " + that.lastname,
                      6 * 60 * 60 * 1000
                    );
                    sessionStorage.removeItem("um");
                    // window.location = 'http://192.168.1.2:3000/pricing-free-trial'
                    window.location = "http://192.168.1.2:3000/plan-trial";
                  }
                } else {
                  if (res.data.source !== "" && res.data.source !== undefined) {
                    cookies.setCookie(
                      "name",
                      that.firstname + " " + that.lastname,
                      6 * 60 * 60 * 1000
                    );
                    sessionStorage.removeItem("um");
                    window.location = res.data.url;
                  } else {
                    cookies.setCookie(
                      "name",
                      that.firstname + " " + that.lastname,
                      6 * 60 * 60 * 1000
                    );
                    sessionStorage.removeItem("um");
                    // window.location = 'https://fexspace.com/pricing-free-trial'
                    window.location = "https://fexspace.com/plan-trial";
                  }
                }
              } else {
                if (res.data.url !== "") {
                  if (Number(res.data.type) === 1) {
                    cookies.setCookie(
                      "name",
                      that.firstname + " " + that.lastname,
                      6 * 60 * 60 * 1000
                    );
                    cookies.setCookie("email", that.email, 6 * 60 * 60 * 1000);
                    if (
                      this.getCookie("redirect") !== "" &&
                      this.getCookie("redirect") !== null &&
                      this.getCookie("redirect") !== undefined
                    ) {
                      window.location.replace(this.getCookie("redirect"));
                    } else {
                      window.location = "https://app.fexspace.com";
                    }
                  } else {
                    // Redirect user to choose a plan
                    cookies.setCookie(
                      "name",
                      that.firstname + " " + that.lastname,
                      6 * 60 * 60 * 1000
                    );
                    cookies.setCookie("email", that.email, 6 * 60 * 60 * 1000);
                    cookies.setCookie("country", that.country, 6 * 60 * 60 * 1000);
                    cookies.setCookie(
                      "tran_ref",
                      res.data.tran_ref,
                      6 * 60 * 60 * 1000
                    );
                    window.location = res.data.url;
                  }
                } else {
                  if (Number(res.data.type) === 1) {
                    if (
                      this.getCookie("redirect") !== "" &&
                      this.getCookie("redirect") !== null &&
                      this.getCookie("redirect") !== undefined
                    ) {
                      window.location.replace(this.getCookie("redirect"));
                    } else {
                      window.location = "https://app.fexspace.com";
                    }
                  } else {
                    // User has already chosen a plan redirect him to setup account page
                    that.$router.push("/setup-account");
                  }
                }
              }
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    recode(str) {
      let last_text = str[str.length - 1];
      let st = "";
      for (let i = 0; i < Number(last_text); i++) {
        st += "=";
      }
      let newstr = str.substr(0, [str.length - 1]);
      return newstr + st;
    },
    isValidURL(string) {
      var res = string.match(
        /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
      );
      return res !== null;
    }
  },
  async created() {
    let { data } = await axios({
      url: process.env.VUE_APP_COUNTRY_CHECK,
      method: "GET",
    });
    // let { ldata } = await axios.get(`https://extreme-ip-lookup.com/json/`)

    if (data === undefined) {
      this.ng = false;
      this.country = "";
    } else {
      this.country = data.country;
      this.ng = data.ng;
    }
  },
  mounted() {
    this.year = new Date().getFullYear();

    if (this.$route.query.redirect !== undefined) {
      if (this.isValidURL(this.$route.query.redirect)) {
        cookies.setCookie(
          "redirect",
          this.$route.query.redirect,
          6 * 60 * 60 * 1000
        );
      } else {
        cookies.setCookie("redirect", this.$route.query.redirect, 0);
      }
    }

    if (this.$route.query.code !== undefined) {
      let data = atob(this.$route.query.code);
      this.email = JSON.parse(data).email;
      this.code = JSON.parse(data).code;
    }

    if (this.$route.query.ref !== undefined) {
      this.ref = this.$route.query.ref;
    }

    sessionStorage.setItem("um", this.$route.query.um);
  },
};
</script>
